import {
    AccrualReviewStatus,
    ImporterErrors,
} from "../types/financialDocument";
import { isImporterAccrualQueue } from "./financialDocument";

export const ACCRUAL_REVIEW_STATUS_BY_ERROR = new Map<
    ImporterErrors,
    AccrualReviewStatus
>([
    [
        ImporterErrors.ACCRUAL_WRONG_WORKSPACE,
        AccrualReviewStatus.WRONG_WORKSPACE,
    ],
    [ImporterErrors.ACCRUAL_WRONG_ENTITY, AccrualReviewStatus.WRONG_ENTITY],
    [
        ImporterErrors.ACCRUAL_UNREADABLE_FILE,
        AccrualReviewStatus.EXTRACTION_FAILED,
    ],
    [
        ImporterErrors.ACCRUAL_NOT_ACCRUAL_DOCUMENT,
        AccrualReviewStatus.NOT_ACCRUAL_DOCUMENT,
    ],
    [
        ImporterErrors.ACCRUAL_WRONG_DOCUMENT_TYPE,
        AccrualReviewStatus.NOT_ACCRUAL_DOCUMENT,
    ],
    [ImporterErrors.EXTRACTION_FAILED, AccrualReviewStatus.EXTRACTION_FAILED],
    [ImporterErrors.ACCRUAL_MISSING_ENTITY, AccrualReviewStatus.MISSING_FIELDS],
    [ImporterErrors.ACCRUAL_NO_LINE_ITEMS, AccrualReviewStatus.MISSING_FIELDS],
    [
        ImporterErrors.ACCRUAL_MISSING_DOCUMENT_NUMBER,
        AccrualReviewStatus.MISSING_FIELDS,
    ],
    [
        ImporterErrors.ACCRUAL_MISSING_DUE_DATE,
        AccrualReviewStatus.MISSING_FIELDS,
    ],
    [
        ImporterErrors.ACCRUAL_MISSING_ACCOUNT,
        AccrualReviewStatus.MISSING_FIELDS,
    ],
    [
        ImporterErrors.ACCRUAL_UNCONFIRMED_ACCOUNT,
        AccrualReviewStatus.CONFIRM_ACCOUNTS,
    ],
    [
        ImporterErrors.ACCRUAL_UNCONFIRMED_ITEM,
        AccrualReviewStatus.CONFIRM_ITEMS,
    ],
    [
        ImporterErrors.ACCRUAL_LINE_ITEMS_DONT_SUM_TO_TOTAL,
        AccrualReviewStatus.TOTALS_MISMATCH,
    ],
    [
        ImporterErrors.ACCRUAL_UNCONFIRMED_COUNTERPARTY,
        AccrualReviewStatus.CONFIRM_COUNTERPARTY,
    ],
    [
        ImporterErrors.ACCRUAL_COUNTERPARTY_DETAILS_CHANGED,
        AccrualReviewStatus.COUNTERPARTY_CHANGED,
    ],
    [
        ImporterErrors.ACCRUAL_MISSING_COUNTERPARTY,
        AccrualReviewStatus.COUNTERPARTY_REQUIRED,
    ],
    [ImporterErrors.ACCRUAL_POSSIBLE_DUPLICATE, AccrualReviewStatus.DUPLICATE],
    [ImporterErrors.FOREIGN_CURRENCY, AccrualReviewStatus.FOREIGN_CURRENCY],
    [ImporterErrors.PERIOD_IS_LOCKED, AccrualReviewStatus.PERIOD_LOCKED],
    [ImporterErrors.ACCRUAL_PARTIALLY_PAID, AccrualReviewStatus.PARTIALLY_PAID],
]);

export const TERMINAL_ACCRUAL_REVIEW_STATUSES = [
    AccrualReviewStatus.EXTRACTION_FAILED,
    AccrualReviewStatus.NOT_ACCRUAL_DOCUMENT,
    AccrualReviewStatus.WRONG_WORKSPACE,
];

interface AccrualReviewStatusInput {
    importerQueue: string | null;
    importerErrors: ImporterErrors[] | null;
    dismissedImporterErrors: ImporterErrors[] | null;
}

export function getAccrualReviewStatus({
    importerQueue,
    importerErrors,
    dismissedImporterErrors,
}: AccrualReviewStatusInput): AccrualReviewStatus | null {
    if (!importerQueue || !isImporterAccrualQueue(importerQueue)) {
        return null;
    }

    const statuses = new Set<AccrualReviewStatus>();
    for (const error of importerErrors ?? []) {
        const reviewStatus = ACCRUAL_REVIEW_STATUS_BY_ERROR.get(error);
        if (reviewStatus && !dismissedImporterErrors?.includes(error)) {
            statuses.add(reviewStatus);
        }
    }

    const terminalStatus = TERMINAL_ACCRUAL_REVIEW_STATUSES.find((terminal) =>
        statuses.has(terminal),
    );
    if (terminalStatus) {
        return terminalStatus;
    }
    if (statuses.size > 1) {
        return AccrualReviewStatus.MULTIPLE_ISSUES;
    }

    const [status] = statuses;
    return status ?? null;
}
